export const ADDRESS_REGEX = {
  county: () => {
    const disallowList = [
      'US',
      'U.S',
      'U.S.',
      'USA',
      'U.SA',
      'U.S.A',
      'U.S.A.',
      'United States',
      'UnitedStates',
      'United States of America',
      'UnitedStatesOfAmerica',
    ];
    return `^(?!(${disallowList.join('|')})$)`;
  },
};

export const ALLOWED_FILE_TYPES = ['.heic', '.jpeg', '.jpg', '.pdf', '.png'];

export const API_ENDPOINTS = {
  downloadPdf: '/caregivers_assistance_claims/download_pdf',
  facilities: '/caregivers_assistance_claims/facilities',
  fileUpload: '/v0/form1010cg/attachments',
  submission: '/v0/caregivers_assistance_claims',
};

export const DEFAULT_SIGNATURE_STATE = {
  checked: false,
  dirty: false,
  matches: false,
  value: '',
};

export const MAX_FILE_SIZE_MB = 10;

export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

export const FORM_KEYS = Object.freeze({
  facilitiesApi: 'view:useFacilitiesApi',
});

export const FORM_TOGGLES = [
  {
    toggleName: 'caregiverUseFacilitiesApi',
    formKey: FORM_KEYS.facilitiesApi,
  },
];
